import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42fb8a60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-190 pt-16 pr-40" }
const _hoisted_2 = { class: "c-magic-line" }
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 1,
  class: "mt-35"
}
const _hoisted_5 = { class: "text-roman mt-35" }

import { computed, Ref } from 'vue';
import navigationStore from '@/shared/navigation/navigation.store';
import LogoutLink from '@/shared/navigation/LogoutLink.vue';
import authStore from '@/shared/auth/auth.store';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import { NavigationItemModel } from '@/types/B2CcontentServerContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyBoliaLeftNavigation',
  setup(__props) {

const accountName: Ref<boolean> = computed(() => {
    return authStore.userData.name;
});

const items: Ref<NavigationItemModel[]> = computed(() => {
    return navigationStore.myBoliaNavigation[0]?.items ?? [] as NavigationItemModel[];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.name + idx
      }, [
        _createVNode(RouterLinkConditional, {
          to: item.url,
          title: item.name,
          "spa-enabled": item.spaLink,
          class: "text-20 mb-8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["to", "title", "spa-enabled"]),
        (idx === 0)
          ? (_openBlock(), _createBlock(_Transition, {
              key: 0,
              "leave-active-class": "animated u-anim-dur-2000 u-anim-delay-2000"
            }, {
              default: _withCtx(() => [
                (_unref(accountName))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      title: _unref(accountName),
                      class: "text-11 truncate"
                    }, _toDisplayString(_unref(accountName)), 9, _hoisted_3))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (item.items?.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (subItem, subIdx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: subItem.name + subIdx,
                  class: "mb-15"
                }, [
                  _createVNode(RouterLinkConditional, {
                    to: subItem.url,
                    title: subItem.name,
                    "spa-enabled": subItem.spaLink,
                    class: "c-magic-line inline"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(subItem.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "title", "spa-enabled"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(LogoutLink, { class: "c-magic-line" })
        ])
      ]))
    }), 128))
  ]))
}
}

})